<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-25 16:56:55
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-12 18:43:41
-->
<template>
  <div :class="['x-page-container', background ? 'background' : '']">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'XPage',
    props: {
      background: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  // @import '../../../common/assets/style/variables';

  .x-page-container {
    display: flex;
    overflow: hidden;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;

    .el-pagination {
      text-align: right;

      .el-pagination__total {
        float: left;
      }

      .el-pagination__sizes {
        float: left;
      }
    }

    &.background {
      background-color: #fff;
    }
  }
</style>
